import { List } from "antd";
import styled from "styled-components";

export const ListCss: React.CSSProperties = {
  display: 'flex',
  width: '100%',
  // height: '605px',
  flexDirection: 'column',
  backgroundColor: 'transparent',
  overflow: 'auto',
};

export const MainPageContainer = styled.main`
    width: 100%;
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  ${({ theme }) =>
      theme.media.monitor(
      `
        margin-top: 50px;
      `,
    )}
`;

export const StyledLayout = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-bottom: 20px;
`;

export const StyledButton = styled.button`
  width: 75px;
  height: 75px;
  background: #5A27DB;
  border-radius: 8px;
  font-size: 20px;
  color: #ffffff;
  font-family: 'Suit semi bold';
  ${({ theme }) =>
    theme.media.monitor(
      `
       height: 110px;
       width: 100px;
       font-size: 28px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
      width: 65px;
      height: 65px;
      font-size: 16px;
      `,
    )}
`

export const StyledList = styled(List)`
  row-gap: 15px;
  .ant-list{
    background-color: transparent !important;
  }
  .ant-list-header {
    padding-block: 0px;
  }
  .ant-pagination{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-spin-nested-loading{
    overflow: auto;
    height: 100%;
  }
  .ant-spin-nested-loading::-webkit-scrollbar{
    width: 10px;  
    height: 20px;
  }
  .ant-spin-nested-loading::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.66); /* 스크롤바 색상 */
    border-radius: 10px; /* 스크롤바 둥근 테두리 */
}
  .ant-spin-nested-loading::-webkit-scrollbar-track {
    background: #6E6E6E;  /*스크롤바 뒷 배경 색상*/
  }
  .ant-list-empty-text{
    height: 350px;
  }
  .ant-list-items{
    height: 25vw;
  }
  ${({ theme }) =>
      theme.media.monitor(
      `
        margin-top: 25px;
      `)}
  ${({ theme }) =>
      theme.media.mobile(
      `
        margin-top: 0px;
        padding: 0px !important;
      `,
  )}
`;

export const ListHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TestFields = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 8% 10% 15% 30% 10% 8% 8% 4%;
  grid-column-gap: 1%;
  margin: 0 auto;
  label {
    font-family: 'Suit bold', 'Inter medium';
    font-size: 15px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.78);
    text-indent: 15px;
  }
  ${({ theme }) =>
      theme.media.monitor(
      `
        label {
          font-size: 18px;
        }
      `)}
  ${({ theme }) =>
    theme.media.tablet(
      `
      font-size: 12px;
      label {
        font-family: 'Suit medium', 'Inter medium';
        font-size: 12px;
        font-weight: 400;
      }
      `,
    )}
      ${({ theme }) =>
        theme.media.mobile(
          `
          text-indent: 0px;
          font-size: 11px;
          grid-column-gap: 0%;
          padding-left: 5px;
          padding-right: 5px;
          label {
            font-family: 'Suit regular', 'Inter regular';
            font-size: 9px;
            font-weight: 200;
            text-indent: 1px;
          }
          `,
        )}
`;

export const NonText = styled.div`
    font-family: 'Suit bold';
    font-weight: 700;
    font-size: 1.5vw;
    text-align: center;
    color: rgba(255, 255, 255, 0.71);
    margin: 0 auto;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) =>
      theme.media.monitor(
        `
        font-size: 28px;
        `,
      )}
    ${({ theme }) =>
      theme.media.mobile(
        `
        font-size: 16px;
        height: 70px;
        `,
      )}
`

export const TestLog = styled.li<{ isVisited: boolean}>`
  background: rgba(255, 255, 255, 0.7);;
  margin-bottom: 15px;
  cursor: pointer;
  width: 100%;
  height: 45px;
  display: grid;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  grid-template-columns:  8% 10% 15% 30% 10% 8% 8% 4%;
  grid-column-gap: 1%;
  border-radius: 5px;
  transition: 0.1s ease all;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.78);
  text-overflow: ellipsis;
  opacity: ${(props) => (props.isVisited ? 0.7 : 1)};
  ${({ theme }) =>
      theme.media.monitor(
      `
        height: 60px;
        margin-bottom: 15px;
      `)}
    ${({ theme }) =>
      theme.media.mobile(
      `
        height: 58px;
        padding-left: 10px;
        padding-right: 5px;
      `,
      )}
`;

export const TestItem = styled.p`
  text-indent: 5px;
  font-family: 'Suit medium', 'Inter medium';
  color: rgba(0, 0, 0, 0.78);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  word-break: keep-all;
  font-size: 15px;
  ${({ theme }) =>
      theme.media.monitor(
      `
        text-indent: 20px;
        font-size: 19px;
      `)}
  ${({ theme }) =>
    theme.media.tablet(
      `
      font-size: 12px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
			font-size: 10px;
      white-space: normal;
      text-align: start;
      justify-content: start;
      text-indent: 0px;
      overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        line-height: 1.2;
        text-align: left;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 2 ;
        -webkit-box-orient: vertical;
      `,
    )}
    @media screen and (min-width: 420px) and (max-width: 660px) {
    font-size: 12px;
    }
`;


export const Status = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 auto;
`;

export const StyledStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
`